import decode from 'jwt-decode'
// import { app } from './feathers'

export default class AuthService {
  // Initializing important variables
  constructor(domain) {
    this.domain = process.env.REACT_APP_API_URL || 'http://localhost:3000' // API server domain
    this.fetch = this.fetch.bind(this) // React binding stuff
    this.login = this.login.bind(this)
    this.getProfile = this.getProfile.bind(this)
    this.inMemoryStorage = {}
  }

  /**
   * Should log the candidate for the chatbot
   * @param {string} companyId
   * @param {object} candidate
   * @returns
   */
  async login(companyId, candidate) {
    const { firstname, lastname, email } = candidate

    // Get a token from api server using the fetch api
    return this.fetch('/authentication-candidate', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        company_id: companyId,
        firstname,
        lastname,
        email,
        strategy: 'candidate',
      }),
    }).then((res) => {
      if (res.accessToken === undefined) return
      this.setToken(res.accessToken) // Setting the token in localStorage
      return Promise.resolve(res)
    })
  }

  async signup(companyId, candidate, isNewApply, isDomainJ2BD) {
    const { firstname, lastname, email, atsPassword, requiredAtsFields } =
      candidate

    return this.fetch(
      `/candidates?$populate[]=requiredAtsFields${
        isNewApply ? '&newApply=true' : ''
      }${isDomainJ2BD ? '&domainJ2BD=true' : ''}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          company_id: companyId,
          firstname,
          lastname,
          email,
          atsPassword,
          requiredAtsFields,
        }),
      },
    ).then((res) => this.login(companyId, res).then(() => Promise.resolve(res)))
  }

  loggedIn() {
    // Checks if there is a saved token and it's still valid
    const token = this.getToken() // GEtting token from localstorage
    return !!token && !this.isTokenExpired(token) // handwaiving here
  }

  isTokenExpired(token) {
    try {
      const decoded = decode(token)
      if (decoded.exp < Date.now() / 1000) {
        // Checking if token is expired. N
        return true
      }
      return false
    } catch (err) {
      return false
    }
  }

  isLocalStorageSupported() {
    try {
      const testKey = 'test_key'
      localStorage.setItem(testKey, testKey)
      localStorage.removeItem(testKey)
      return true
    } catch (e) {
      return false
    }
  }

  setToken(idToken) {
    if (this.isLocalStorageSupported()) {
      localStorage.setItem('id_token', idToken)
    } else {
      this.inMemoryStorage.id_token = idToken
    }
  }

  getToken() {
    if (this.isLocalStorageSupported()) {
      return localStorage.getItem('id_token')
    }
    return this.inMemoryStorage.id_token
  }

  logout() {
    if (this.isLocalStorageSupported()) {
      localStorage.removeItem('id_token')
    } else {
      delete this.inMemoryStorage.id_token
    }
  }

  getProfile() {
    // Using jwt-decode npm package to decode the token
    const candidate = decode(this.getToken())

    return {
      candidate,
    }
  }

  fetch(url, options) {
    // performs api calls sending the required authentication headers
    const headers = {
      // 'Accept': 'application/json',
      // 'Content-Type': 'application/json'
    }

    // Setting Authorization header
    // Authorization: Bearer xxxxxxx.xxxxxxxx.xxxxxx
    // if (this.loggedIn()) {
    //   headers.Authorization = `Bearer ${this.getToken()}`
    // }

    return fetch(`${this.domain}${url}`, {
      headers,
      ...options,
    })
      .then(this._checkStatus)
      .then((response) => response.json())
      .then((res) => {
        if (res.accessToken) {
          this.setToken(res.accessToken)
          delete res.accessToken
        }
        return res
      })
  }

  async _checkStatus(response) {
    // raises an error in case response status is not a success
    if (response.status >= 200 && response.status < 300) {
      // Success status lies between 200 to 300
      return response
    }
    throw await response.json()
  }
}
